import React from 'react';
import Icon from '../../../components/AppIcon';

const AdvocallConnection = () => {
  const features = [
    {
      title: 'Etablierte Rechtsexpertise',
      description: 'Über 15 Jahre Erfahrung in der deutschen Rechtsberatung',
      icon: 'Award'
    },
    {
      title: 'Zertifizierte Anwälte',
      description: 'Alle Berater sind bei der Rechtsanwaltskammer registriert',
      icon: 'UserCheck'
    },
    {
      title: 'Vollständige Haftpflichtversicherung',
      description: 'Umfassender Versicherungsschutz für alle Beratungsleistungen',
      icon: 'Shield'
    },
    {
      title: 'DSGVO-konforme Datenverarbeitung',
      description: 'Höchste Standards beim Datenschutz und der Datensicherheit',
      icon: 'Lock'
    }
  ];

  return (
    <div className="bg-slate-50 rounded-xl border border-slate-200 p-6">
      <div className="flex items-center space-x-3 mb-6">
        <div className="flex items-center justify-center w-10 h-10 bg-primary rounded-lg">
          <Icon name="Building2" size={20} color="white" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-text-primary">ADVOCALL RECHTSANWALTSGESELLSCHAFT MBH</h2>
          <p className="text-sm text-text-secondary">Ihre rechtliche Grundlage für vertrauensvolle Beratung</p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        {features?.map((feature, index) => (
          <div key={index} className="flex items-start space-x-3 p-4 bg-white rounded-lg border border-slate-100">
            <div className="flex items-center justify-center w-8 h-8 bg-primary/10 rounded-lg">
              <Icon name={feature?.icon} size={16} color="var(--color-primary)" />
            </div>
            <div>
              <h3 className="font-medium text-text-primary mb-1">{feature?.title}</h3>
              <p className="text-sm text-text-secondary">{feature?.description}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="bg-white rounded-lg border border-slate-100 p-4 mb-4">
        <div className="flex items-start space-x-3">
          <Icon name="MapPin" size={16} color="var(--color-primary)" className="mt-1" />
          <div>
            <h4 className="font-medium text-text-primary mb-2">Geschäftssitz Berlin</h4>
            <p className="text-sm text-text-secondary mb-2">
              ADVOCALL RECHTSANWALTSGESELLSCHAFT MBH<br />
              Kurfürstendamm 14<br />
              10719 Berlin<br />
              Deutschland
            </p>
            <div className="text-sm text-text-secondary">
              <p><strong>Handelsregister:</strong> HRB 123759 (Amtsgericht Frankfurt am Main)</p>
              <p><strong>Geschäftsführer:</strong> Mirco Lehr</p>
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between">
        <div className="text-sm text-text-secondary">
          <p>Mitglied der Rechtsanwaltskammer</p>
          <p>Berufsrechtliche Regelungen einsehbar unter: <span className="text-primary">brak.de</span></p>
        </div>
      </div>
    </div>
  );
};

export default AdvocallConnection;